import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'

import '../src/util/install_sentry'
import '../src/site/reform_db/chart_for_contracted_construction_price_range'
import '../src/site/reform_db/chart_for_contracted_part_type_distribution_chart'
import 'Components/site/site_footer/component'
import 'Components/site/site_header/component'
import 'Components/site/site_header_navigation/component'
import 'Components/basics/breadcrumb/component'
import 'Components/site/company_link_header/component'
import 'Components/site/company_ranking_by_client/component'
import 'Components/site/reason_points/component'
import 'Components/site/tab_navigation/component'
import 'Components/site/company_card/component'
import 'Components/site/example_card/component'
import 'Components/site/carousel_light/component'
import 'Components/site/advice_card/component'
import 'Components/site/review_card/component'
import 'Components/site/company_call_to_action/component'
import 'Components/site/call_to_action_button/component'
import 'Components/site/call_to_action_link/component'
import 'Components/site/strong_points/component'
import 'Components/site/available_payments_and_supports/component'
import 'Components/site/available_services/component'
import 'Components/site/available_insurances/component'
import 'Components/site/available_card_list/component'
import 'Components/site/available_card/component'
import 'Components/site/area_links/component'
import 'Components/site/company_contract/component'
import 'Components/site/contract_price_table/component'
import 'Components/site/company_evaluation/component'
import 'Components/site/floating/component'

import spToggleNav from '../src/spToggleNav/spToggleNav'

$(() => {
  spToggleNav()
})

const chart = require('chart.js')
